import { ReactNode } from 'react'
import styled from 'styled-components'
import { Box } from '../UI/Box'
import {
  stopPropagation,
  ModalTitle,
  ModalText,
  ModalErrorMessage,
} from '../EmbeddableModal'
import { TaskContainer } from './styles'
import TaskDescription from './TaskDescription'
import { H4, P } from '../Library/Typeography'

export const Wrapper = styled(Box)`
  position: relative;
  max-width: 640px;
  z-index: 12;
  button {
    max-width: 300px;
    margin: auto;
  }
`

const Container = styled(TaskContainer)``

const TaskBody = ({
  taskId,
  title,
  description,
  extra,
  error,
  actions,
}: {
  taskId: number
  title: string
  description: string
  error: ReactNode
  extra?: ReactNode
  actions: ReactNode
}) => {
  return (
    <Container onClick={stopPropagation} c>
      <Wrapper direction="column" g={24}>
        <H4 s="XL">{title}</H4>
        <TaskDescription>{description}</TaskDescription>
        {extra}
        {error && <ModalErrorMessage>{error}</ModalErrorMessage>}
        {actions}
      </Wrapper>
    </Container>
  )
}

export default TaskBody
